import { createStore } from 'vuex'

export default createStore({
  state: {
    token: '',
    personalInformation: {} // 个人信息
  },
  mutations: {
    tokenClick(state, params) {
      state.token = params
    },
    personalInformation(state, params) {
      state.personalInformation = params
    }
  },
  actions: {
  },
  modules: {
  }
})
